import { useMutation } from '@tanstack/react-query';
import { toast } from '@huspy/forge/shared';
import { useTranslation } from 'react-i18next';
import { bankApplicationsApi } from '@modules/opportunities/entities/bankApplication/api';
import { trackAmplitudeEvent } from '@shared/analytics/amplitude';
import { USER_EVENTS } from '@shared/analytics/events';

const useRedraftDigitalDocument = (opportunityExternalId: string) => {
  const { t } = useTranslation();
  const {
    mutateAsync,
    isPending,
  } = useMutation({
    mutationKey: ['redraftDigitalDocument'],
    mutationFn: async ({ bankApplicationExternalId, digitalDocumentId }:
    { bankApplicationExternalId: string, digitalDocumentId: string }) => {
      // Track attempt
      trackAmplitudeEvent(USER_EVENTS.CASE.CASE_DIGITAL_BANK_FORM_EDIT_ATTEMPTED, { useContext: true });

      return bankApplicationsApi.redraftDigitalBankApplication(
        {
          opportunityExternalId,
          bankApplicationExternalId,
          digitalDocumentId,
        }
      );
    },
    onSuccess: () => {
      // Track success
      trackAmplitudeEvent(USER_EVENTS.CASE.CASE_DIGITAL_BANK_FORM_EDIT_COMPLETED, { useContext: true });
    },
    onError: (error) => {
      // Track fail
      trackAmplitudeEvent(USER_EVENTS.CASE.CASE_DIGITAL_BANK_FORM_EDIT_FAILED, {
        useContext: true,
        error_message: error.message ?? error,
      });

      const defaultMessage = t('opportunity.caseSubmission.digitalDocument.notifications.generationFailed');
      toast('error', { message: error.message || defaultMessage });
    },
  });

  return { mutateAsync, isPending };
};

export default useRedraftDigitalDocument;
